/* Dense floating sewing/haberdashery SVGs for ALL portal pages */

function Scissors({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="8" stroke="currentColor" strokeWidth="2" fill="none" />
      <circle cx="18" cy="46" r="8" stroke="currentColor" strokeWidth="2" fill="none" />
      <line x1="25" y1="22" x2="52" y2="42" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="25" y1="42" x2="52" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
function Needle({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="12" y1="52" x2="48" y2="8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <circle cx="50" cy="6" r="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M12 52 Q 8 56, 14 58 Q 20 54, 12 52" stroke="currentColor" strokeWidth="1.5" fill="currentColor" opacity="0.3" />
      <path d="M18 44 C 24 48 28 42 22 38" stroke="currentColor" strokeWidth="1" strokeDasharray="2 3" opacity="0.4" />
    </svg>
  );
}
function Thread({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="16" y="20" width="32" height="28" rx="4" stroke="currentColor" strokeWidth="2" fill="currentColor" opacity="0.06" />
      <ellipse cx="32" cy="18" rx="14" ry="6" stroke="currentColor" strokeWidth="2" fill="none" />
      <line x1="32" y1="12" x2="32" y2="6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M 20 34 Q 26 28 32 34 Q 38 40 44 34" stroke="currentColor" strokeWidth="1.5" fill="none" opacity="0.5" />
    </svg>
  );
}
function SewButton({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="22" stroke="currentColor" strokeWidth="2" fill="currentColor" opacity="0.04" />
      <circle cx="32" cy="32" r="16" stroke="currentColor" strokeWidth="1" opacity="0.3" />
      <circle cx="26" cy="28" r="2.5" fill="currentColor" opacity="0.3" />
      <circle cx="38" cy="28" r="2.5" fill="currentColor" opacity="0.3" />
      <circle cx="26" cy="38" r="2.5" fill="currentColor" opacity="0.3" />
      <circle cx="38" cy="38" r="2.5" fill="currentColor" opacity="0.3" />
    </svg>
  );
}
function Thimble({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40 Q20 16 32 16 Q44 16 44 40" stroke="currentColor" strokeWidth="2" fill="currentColor" opacity="0.05" />
      <line x1="20" y1="40" x2="44" y2="40" stroke="currentColor" strokeWidth="2" />
      <circle cx="28" cy="24" r="1.5" fill="currentColor" opacity="0.25" />
      <circle cx="36" cy="24" r="1.5" fill="currentColor" opacity="0.25" />
      <circle cx="32" cy="20" r="1.5" fill="currentColor" opacity="0.25" />
      <circle cx="28" cy="30" r="1.5" fill="currentColor" opacity="0.25" />
      <circle cx="36" cy="30" r="1.5" fill="currentColor" opacity="0.25" />
      <circle cx="32" cy="34" r="1.5" fill="currentColor" opacity="0.25" />
    </svg>
  );
}
function FabricRoll({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="22" cy="32" rx="10" ry="18" stroke="currentColor" strokeWidth="2" fill="currentColor" opacity="0.04" />
      <line x1="22" y1="14" x2="54" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="22" y1="50" x2="54" y2="50" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M54 14 Q58 32 54 50" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 3" opacity="0.3" />
    </svg>
  );
}
function PinCushion({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="32" cy="40" rx="22" ry="14" stroke="currentColor" strokeWidth="2" fill="currentColor" opacity="0.08" />
      <ellipse cx="32" cy="38" rx="22" ry="12" stroke="currentColor" strokeWidth="2" fill="none" />
      <line x1="24" y1="38" x2="22" y2="16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="22" cy="14" r="2.5" fill="currentColor" opacity="0.4" />
      <line x1="32" y1="36" x2="34" y2="12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="34" cy="10" r="2.5" fill="currentColor" opacity="0.4" />
      <line x1="40" y1="36" x2="42" y2="18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="42" cy="16" r="2.5" fill="currentColor" opacity="0.4" />
    </svg>
  );
}
function Zipper({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="28" y="4" width="8" height="56" rx="2" stroke="currentColor" strokeWidth="1.5" fill="currentColor" opacity="0.04" />
      <path d="M28 16 L24 20 L28 24 L24 28 L28 32 L24 36 L28 40 L24 44 L28 48" stroke="currentColor" strokeWidth="1.2" opacity="0.3" />
      <path d="M36 16 L40 20 L36 24 L40 28 L36 32 L40 36 L36 40 L40 44 L36 48" stroke="currentColor" strokeWidth="1.2" opacity="0.3" />
      <rect x="26" y="6" width="12" height="8" rx="2" stroke="currentColor" strokeWidth="1.5" fill="currentColor" opacity="0.08" />
    </svg>
  );
}
function DressForm({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 12 Q24 6 32 6 Q40 6 40 12 L42 36 Q42 42 32 44 Q22 42 22 36 Z" stroke="currentColor" strokeWidth="2" fill="currentColor" opacity="0.04" />
      <line x1="32" y1="44" x2="32" y2="56" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="24" y1="56" x2="40" y2="56" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
function MeasuringTape({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 32 Q 8 16 24 16 L 48 16 Q 56 16 56 24 L 56 32" stroke="currentColor" strokeWidth="2" fill="none" />
      <rect x="4" y="30" width="12" height="18" rx="3" stroke="currentColor" strokeWidth="2" fill="currentColor" opacity="0.06" />
      <line x1="24" y1="16" x2="24" y2="22" stroke="currentColor" strokeWidth="1" opacity="0.4" />
      <line x1="32" y1="16" x2="32" y2="20" stroke="currentColor" strokeWidth="1" opacity="0.4" />
      <line x1="40" y1="16" x2="40" y2="22" stroke="currentColor" strokeWidth="1" opacity="0.4" />
    </svg>
  );
}

const Icons = [Scissors, Needle, Thread, SewButton, Thimble, FabricRoll, PinCushion, Zipper, DressForm, MeasuringTape];
const anims = ["animate-float", "animate-float-slow", "animate-float-reverse", "animate-drift", "animate-drift-wide", "animate-float-diag"];

// Generate a dense field of items spread across the viewport
function generateItems(count, opacityBase) {
  const items = [];
  for (let i = 0; i < count; i++) {
    const Icon = Icons[i % Icons.length];
    const anim = anims[i % anims.length];
    const row = Math.floor(i / 4);
    const col = i % 4;
    // Spread across viewport with some randomness
    const top = `${(row * 18 + (col * 5)) % 95}%`;
    const left = col < 2 ? `${1 + col * 3 + (row % 3)}%` : undefined;
    const right = col >= 2 ? `${1 + (col - 2) * 3 + (row % 3)}%` : undefined;
    const sizes = ["w-6 h-6", "w-7 h-7", "w-8 h-8", "w-9 h-9", "w-10 h-10", "w-11 h-11", "w-12 h-12"];
    const size = sizes[i % sizes.length];
    const delay = `${(i * 0.7) % 6}s`;
    const opacity = opacityBase + (i % 4) * 0.01;
    const rotations = ["", "rotate-12", "-rotate-12", "rotate-45", "-rotate-45", "rotate-6"];
    const rotate = rotations[i % rotations.length];
    items.push({ Icon, anim, top, left, right, size, delay, opacity, rotate });
  }
  return items;
}

const portalItems = generateItems(30, 0.06);

export default function BackgroundAnimations() {
  return (
    <div className="fixed inset-0 pointer-events-none select-none overflow-hidden z-0" aria-hidden="true">
      {portalItems.map((item, i) => {
        const { Icon, size, anim, delay, opacity, rotate, top, left, right } = item;
        const posStyle = { top };
        if (left) posStyle.left = left;
        if (right) posStyle.right = right;
        posStyle.animationDelay = delay;
        return (
          <div
            key={`bg-${i}`}
            className={`absolute text-[#5C3A2E] ${size} ${anim} ${rotate}`}
            style={{ ...posStyle, opacity }}
          >
            <Icon className="w-full h-full" />
          </div>
        );
      })}
      {/* Grain texture overlay */}
      <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='1'/%3E%3C/svg%3E\")" }} />
    </div>
  );
}
